export const checkElementExistence = (selectors: string | string[]): boolean => {
  const selectorsArray = Array.isArray(selectors)
    ? selectors
    : [selectors];

  return selectorsArray.some(
    (selector) => (document.querySelector(selector) !== null),
  );
};
